import React, { useState } from "react"
import { IoIosCloseCircleOutline } from "react-icons/io"
import Popover from "react-popover"
import { H2 } from "../headings/index"
import {
  AssistenciasWrapper,
  AssistenciasContainer,
  AssistenciaItem,
  PopoverContent,
} from "./style"

import AssistenciaImg from "../../images/assistencia.png"
import KitAssistenciaImg from "../../images/kit-assistencia.png"
import Estrela3 from "../../images/tres-estrelas.png"
import Estrela2 from "../../images/duas-estrelas.png"
import Estrela1 from "../../images/estrela.png"

const assistencias = [
  {
    title: "Emergencial Essencial",
    content: {
      title: "Emergencial Essencial",
      content: "Eletricista, Encanador, Chaveiro, Vidraceiro, Indicação de mão de obra, Vigilância, Cobertura provisória de telhados e Desentupimento de tubulações.",
      position: "left",
    },
    starCount: 1,
  },
  {
    title: "Emergencial Completo",
    content: {
      title: "Emergencial Completo",
      content: "Eletricista, Encanador, Chaveiro, Vidraceiro, Indicação de mão de obra, Vigilância, Cobertura provisória de telhados, Desentupimento de tubulações, Dedetização, Substituição de telhas, Limpeza de ar condicionado, Limpeza de caixa d'água e Limpeza de residência.",
      position: "right",
    },
    starCount: 2,
  },
  {
    title: "Emergencial Completo + PET",
    content: {
      title: "Emergencial Completo + PET",
      content: "Eletricista, Encanador, Chaveiro, Vidraceiro, Indicação de mão de obra, Vigilância, Cobertura provisória de telhados, Desentupimento de tubulações, Dedetização, Substituição de telhas, Limpeza de ar condicionado, Limpeza de caixa d'água, Limpeza de residência, (PET)Assistência funeral, (PET)Transporte funerário, (PET)Consultas veterinárias e (PET)Aplicação de vacinas em domicílio (duas intervenções durante a vigência).",
      position: "right",
    },
    starCount: 3,
  },
]

const Item = ({ title, content, starCount }) => {
  const [isOpen, setIsOpen] = useState(false)

  const validStar = count => {
    if(count === 1) {
      return Estrela1
    } else if (count === 2) {
      return Estrela2
    } else if (count === 3) {
      return Estrela3
    }
  }

  const tooglePopover = () => {
    setIsOpen(!isOpen)
  }

  return (
    <AssistenciaItem>
      <strong className="item-title">{title}</strong>
      <img src={KitAssistenciaImg} />
      <img
        src={validStar(starCount)}
        className="star"
        alt={starCount === 1 ? "Estrela" : "Estrelas"}
      />
      <Popover
        isOpen={isOpen}
        onOuterAction={tooglePopover}
        preferPlace={content.position}
        body={[
          <PopoverContent>
            <button onClick={tooglePopover}>
              <IoIosCloseCircleOutline size={24} />
            </button>
            <strong>{content.title}</strong>
            <p>{content.content}</p>
            <p>
              Obs: 
              <br />
              <b>Limite de intervenção:</b> A limitação global dos serviços deste pacote será de até 3 (três) intervenções por ano, independentemente do serviço solicitado.
              <br />
              <b>Abrangência:</b> Território nacional
            </p>
          </PopoverContent>,
        ]}
      >
        <a className="more-info" onClick={tooglePopover}>
          Mais informações
        </a>
      </Popover>
    </AssistenciaItem>
  )
}

const Assistencias = () => {
  return (
    <AssistenciasWrapper>
      <H2>Conheça Nossas Assistências</H2>
      <p>
        Seguro essencial para imóveis alugados. Seguro, prático e cabe no seu
        bolso.
      </p>

      <AssistenciasContainer>
        <div className="left">
          <img src={AssistenciaImg} width="280" />
          <p>
            Você escolhe o pacote de assistência e deixa o seguro conforme sua
            necessidade.
          </p>
          <a href="/seguro/docs/Condicoes_Gerais_Apolice.pdf" target="_blank">
            Ver Condições Gerais
          </a>
        </div>
        <div className="right">
          {assistencias.map((item, index) => (
            <Item key={index} {...item} />
          ))}
        </div>
      </AssistenciasContainer>
    </AssistenciasWrapper>
  )
}
export default Assistencias
